// NOTICE: KAPTION-INTEGRATION
// usage-analytics.CONTRACT.1 — Shared constants for the product-usage analytics
// client. The 14 event names here are part of the SHARED CONTRACT with the
// usage-analytics Cloudflare Worker / backend; do NOT rename without updating
// both sides.

// usage-analytics.CONTRACT.1 — the 14 canonical event names.
export const USAGE_ANALYTICS_EVENTS = Object.freeze({
  LIVE_TRANSLATION_TOGGLED: 'live_translation_toggled',
  LIVE_TRANSLATION_PERFORMED: 'live_translation_performed',
  MESSAGE_SENT: 'message_sent',
  PRIVATE_NOTE_CREATED: 'private_note_created',
  REPLY_QUOTED: 'reply_quoted',
  REACTION_ADDED: 'reaction_added',
  REACTION_REMOVED: 'reaction_removed',
  SUGGESTION_SHOWN: 'suggestion_shown',
  SUGGESTION_CANCELED: 'suggestion_canceled',
  SUGGESTION_ACCEPTED: 'suggestion_accepted',
  SUGGESTION_SENT: 'suggestion_sent',
  // usage-analytics.SUGGESTIONS.4 — 👍/👎 quality verdict on a shown suggestion.
  // Carries the same client suggestion_id as shown/accepted; verdict in metadata.
  SUGGESTION_FEEDBACK: 'suggestion_feedback',
  FILTER_APPLIED: 'filter_applied',
  // usage-analytics.OPEN.1 — emitted once per conversation entry.
  CONVERSATION_OPENED: 'conversation_opened',
});

// usage-analytics.TRANSPORT.1 — batching/transport tuning.
export const FLUSH_BATCH_SIZE = 20;
export const FLUSH_INTERVAL_MS = 5000;
export const EVENTS_PATH = '/v1/events';
export const SOURCE = 'dashboard';

// usage-analytics.TOKEN.3 — refresh the JWT at 80% of its TTL.
export const TOKEN_REFRESH_RATIO = 0.8;

// usage-analytics.PRIVACY.1 — char-count buckets. We bucket the LENGTH of text
// (never the text itself) so we can reason about message size without ever
// shipping content. Boundaries are inclusive of the lower edge.
//   empty:0  xs:1-20  s:21-80  m:81-280  l:281-800  xl:800+
export function lengthBucket(n) {
  const len = Number.isFinite(n) ? n : 0;
  if (len <= 0) return 'empty';
  if (len <= 20) return 'xs';
  if (len <= 80) return 's';
  if (len <= 280) return 'm';
  if (len <= 800) return 'l';
  return 'xl';
}

// usage-analytics.PRIVACY.4 — stable, non-reversible hash of a string, used ONLY
// to detect whether an inserted AI suggestion was edited before send (compare
// hashes) without ever transmitting the text. djb2; returned as an unsigned
// base36 string. NOT cryptographic — collision-resistance is not required, only
// change-detection.
/* eslint-disable no-bitwise -- bitwise ops are intrinsic to the djb2 hash */
export function textHash(str) {
  const s = typeof str === 'string' ? str : '';
  let hash = 5381;
  for (let i = 0; i < s.length; i += 1) {
    hash = (hash * 33) ^ s.charCodeAt(i);
  }
  // >>> 0 -> unsigned 32-bit
  return (hash >>> 0).toString(36);
}
/* eslint-enable no-bitwise */

// usage-analytics.IDENTITY.1 — normalize a Chatwoot/Kaption channel_type string
// to a short, bounded enum. Anything unrecognized collapses to 'other' so we
// never emit a high-cardinality / PII-bearing channel label.
export function normalizeChannelType(channelType) {
  if (!channelType || typeof channelType !== 'string') return 'other';
  const ct = channelType.toLowerCase();
  if (ct.includes('whatsapp')) return 'whatsapp';
  if (ct.includes('email')) return 'email';
  if (ct.includes('web_widget') || ct.includes('webwidget'))
    return 'web_widget';
  // Channel::Api is the generic programmable channel.
  if (ct.includes('::api') || ct.endsWith('api') || ct === 'channel::api') {
    return 'api';
  }
  return 'other';
}
